import { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { Download, FileSpreadsheet } from "lucide-react";
import { api, formatRupiah, formatApiError } from "../lib/api";

export default function AdminReports() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/admin/reports/members").then((r) => setRows(r.data)).catch((e) => setError(formatApiError(e)));
  }, []);

  const downloadCsv = () => {
    const headers = ["No Anggota", "Nama", "No KTP", "No HP", "Jenis", "Lama Keanggotaan", "Simpanan Pokok", "Simpanan Wajib", "Simpanan Sukarela", "Total Simpanan"];
    const lines = [headers.join(",")];
    rows.forEach((r) => {
      lines.push([
        r.member_number, r.full_name, r.ktp_no, r.phone, r.membership_type,
        r.duration_label, r.simpanan_pokok, r.simpanan_wajib, r.simpanan_sukarela, r.total_simpanan,
      ].map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(","));
    });
    const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `laporan-anggota-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-end justify-between flex-wrap gap-3">
          <div>
            <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight text-brand-ink">Laporan Anggota</h1>
            <p className="text-brand-muted text-sm mt-1">Daftar anggota aktif dengan ringkasan simpanan.</p>
          </div>
          <button onClick={downloadCsv} data-testid="download-csv-btn" className="rounded-full bg-brand text-white px-5 py-2.5 text-sm flex items-center gap-2 hover:bg-brand-hover transition">
            <Download size={14} /> Unduh CSV
          </button>
        </div>

        {error && <div className="rounded-2xl bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3">{error}</div>}

        <div className="bg-white rounded-3xl border border-brand/10 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="reports-table">
              <thead className="bg-brand-soft/60 text-left text-brand-muted">
                <tr>
                  <th className="px-4 py-3">No Anggota</th>
                  <th className="px-4 py-3">Nama</th>
                  <th className="px-4 py-3">Lama</th>
                  <th className="px-4 py-3 text-right">Simpanan Pokok</th>
                  <th className="px-4 py-3 text-right">Simpanan Wajib</th>
                  <th className="px-4 py-3 text-right">Simpanan Sukarela</th>
                  <th className="px-4 py-3 text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? <tr><td colSpan={7} className="px-4 py-10 text-center text-brand-muted"><FileSpreadsheet className="inline mr-2" size={14} />Belum ada anggota aktif</td></tr>
                : rows.map((r) => (
                  <tr key={r.member_id} className="border-t border-brand/10 hover:bg-brand-soft/30">
                    <td className="px-4 py-3 font-medium text-brand-ink">{r.member_number}</td>
                    <td className="px-4 py-3"><div>{r.full_name}</div><div className="text-xs text-brand-muted">{r.membership_type}</div></td>
                    <td className="px-4 py-3 text-brand-muted">{r.duration_label}</td>
                    <td className="px-4 py-3 text-right">{formatRupiah(r.simpanan_pokok)}</td>
                    <td className="px-4 py-3 text-right">{formatRupiah(r.simpanan_wajib)}</td>
                    <td className="px-4 py-3 text-right">{formatRupiah(r.simpanan_sukarela)}</td>
                    <td className="px-4 py-3 text-right font-semibold text-brand">{formatRupiah(r.total_simpanan)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
